var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useField, useFormikContext } from 'formik';
import React from 'react';
import styled from 'styled-components';
import { Grid, IconButton, InputAdornment, MenuItem, TextField } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
const StyledGrid = styled(Grid) `
  display: flex;
  flex-direction: column;
`;
export const FormikSelectField = props => {
    let { variant, name, children, grid, submitOnChange, clearable, options } = props, childProps = __rest(props, ["variant", "name", "children", "grid", "submitOnChange", "clearable", "options"]);
    const formik = useFormikContext();
    const [field, meta, { setValue, setTouched }] = useField(name);
    if (!grid) {
        // default field to expand entire width of form
        grid = { xs: 12 };
    }
    if (submitOnChange) {
        childProps.onChange = (event) => {
            field.onChange(event);
            setTouched(true);
            formik.submitForm();
        };
    }
    const InputProps = childProps.InputProps || {};
    const resetValue = typeof clearable === 'boolean' ? '' : clearable;
    if (clearable && field.value) {
        InputProps.endAdornment = (React.createElement(InputAdornment, { position: 'end', className: 'select-field-adornment' },
            React.createElement(IconButton, { size: 'small', onClick: () => {
                    setTouched(true);
                    setValue(resetValue);
                    if (submitOnChange) {
                        formik.submitForm();
                    }
                } },
                React.createElement(ClearIcon, null))));
    }
    return (React.createElement(StyledGrid, Object.assign({ item: true, className: 'formik-select-field' }, grid),
        React.createElement(TextField, Object.assign({ select: true, variant: variant || 'outlined', autoComplete: 'off', error: meta.touched && Boolean(meta.error), helperText: meta.error }, field, childProps, { InputProps: InputProps, name: name }),
            options &&
                options.map(option => typeof option === 'string' ? (React.createElement(MenuItem, { key: option, value: option }, option)) : (React.createElement(MenuItem, { key: option.value, value: option.value }, option.label))),
            children)));
};
export default FormikSelectField;
//# sourceMappingURL=FormikSelectField.js.map